import { FC } from 'react'
import { IconProps } from '.'

export const Upload: FC<IconProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    {...props}
  >
    <path
      d="M13 9.66663V11.8889C13 12.1835 12.883 12.4662 12.6746 12.6745C12.4662 12.8829 12.1836 13 11.8889 13H4.11111C3.81643 13 3.53381 12.8829 3.32544 12.6745C3.11706 12.4662 3 12.1835 3 11.8889V9.66663"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.7779 5.77778L8.00007 3L5.22229 5.77778"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M8 3V9.66668" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export const Plus: FC<IconProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    {...props}
  >
    <path d="M8 3.5V12.5M12.5 8H3.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export const Search: FC<IconProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    {...props}
  >
    <path
      d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M13.9996 13.9999L11.0996 11.0999" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export const Loop: FC<IconProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    {...props}
  >
    <path
      d="M2.52258 12.3577H10.7506C11.6412 12.3577 12.0865 12.3577 12.4267 12.1843C12.7259 12.0319 12.9692 11.7886 13.1216 11.4894C13.295 11.1492 13.295 10.7039 13.295 9.81323V9.16522M2.52258 12.3577L4.31798 10.7614M2.52258 12.3577L4.31798 13.9539M13.4773 3.55435H5.24938C4.35875 3.55435 3.91343 3.55435 3.57326 3.72768C3.27403 3.88014 3.03075 4.12342 2.87828 4.42265C2.70496 4.76282 2.70496 5.20814 2.70496 6.09877V6.74678M13.4773 3.55435L11.682 1.95813M13.4773 3.55435L11.682 5.15056"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const Soundwave: FC<IconProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    {...props}
  >
    <path
      d="M4.66663 4.66669L4.66663 11.3334M1.33325 7.33331L1.33325 8.66665M7.99988 2L7.99988 14M11.3333 4.66669V11.3334M14.6666 7.33331V8.66665"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const Loading: FC<IconProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    {...props}
  >
    <path
      opacity="0.15"
      d="M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z"
    />
    <path
      d="M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2"
      strokeLinecap="round"
    />
  </svg>
)

export const Check: FC<IconProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    {...props}
  >
    <path d="M3 8L6 11L13 4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export const User: FC<IconProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    {...props}
  >
    <path
      d="M2.66663 12.5334C2.66663 10.7661 4.09932 9.33337 5.86663 9.33337H10.1333C11.9006 9.33337 13.3333 10.7661 13.3333 12.5334C13.3333 13.7116 12.3782 14.6667 11.2 14.6667H4.79996C3.62175 14.6667 2.66663 13.7116 2.66663 12.5334Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6667 4.00004C10.6667 5.4728 9.4728 6.66671 8.00004 6.66671C6.52728 6.66671 5.33337 5.4728 5.33337 4.00004C5.33337 2.52728 6.52728 1.33337 8.00004 1.33337C9.4728 1.33337 10.6667 2.52728 10.6667 4.00004Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const Share: FC<IconProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    {...props}
  >
    <path
      d="M5.72682 9.00671L10.2802 11.66M10.2735 4.34005L5.72682 6.99338M14 3.33337C14 4.43794 13.1046 5.33337 12 5.33337C10.8954 5.33337 10 4.43794 10 3.33337C10 2.2288 10.8954 1.33337 12 1.33337C13.1046 1.33337 14 2.2288 14 3.33337ZM6 8.00004C6 9.10461 5.10457 10 4 10C2.89543 10 2 9.10461 2 8.00004C2 6.89547 2.89543 6.00004 4 6.00004C5.10457 6.00004 6 6.89547 6 8.00004ZM14 12.6667C14 13.7713 13.1046 14.6667 12 14.6667C10.8954 14.6667 10 13.7713 10 12.6667C10 11.5621 10.8954 10.6667 12 10.6667C13.1046 10.6667 14 11.5621 14 12.6667Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const Details: FC<IconProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    {...props}
  >
    <path
      d="M9.33337 1.37874V3.19998C9.33337 3.94672 9.33337 4.32008 9.4787 4.6053C9.60653 4.85618 9.8105 5.06016 10.0614 5.18799C10.3466 5.33331 10.72 5.33331 11.4667 5.33331H13.288M8.66667 10.3333C8.66667 11.0697 8.06971 11.6667 7.33333 11.6667C6.59695 11.6667 6 11.0697 6 10.3333C6 9.59695 6.59695 9 7.33333 9C8.06971 9 8.66667 9.59695 8.66667 10.3333ZM8.66667 10.3333L8.66663 6.66663L9.99996 7.99996M13.3334 6.52238V10.1867C13.3334 11.7549 13.3334 12.5389 13.0282 13.1379C12.7598 13.6647 12.3314 14.0931 11.8046 14.3615C11.2056 14.6667 10.4216 14.6667 8.85341 14.6667H7.14675C5.5786 14.6667 4.79453 14.6667 4.19557 14.3615C3.66872 14.0931 3.24038 13.6647 2.97193 13.1379C2.66675 12.5389 2.66675 11.7549 2.66675 10.1867V5.81337C2.66675 4.24523 2.66675 3.46115 2.97193 2.8622C3.24038 2.33535 3.66872 1.907 4.19557 1.63856C4.79453 1.33337 5.5786 1.33337 7.14675 1.33337H8.1444C8.82926 1.33337 9.17169 1.33337 9.49393 1.41074C9.77963 1.47933 10.0528 1.59246 10.3033 1.74598C10.5858 1.91914 10.828 2.16127 11.3122 2.64554L12.0213 3.35455C12.5055 3.83881 12.7477 4.08094 12.9208 4.36351C13.0743 4.61403 13.1875 4.88716 13.2561 5.17286C13.3334 5.4951 13.3334 5.83753 13.3334 6.52238Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const Home: FC<IconProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    {...props}
  >
    <path
      d="M2 5.99992L8 1.33325L14 5.99992V13.3333C14 13.6869 13.8595 14.026 13.6095 14.2761C13.3594 14.5261 13.0203 14.6666 12.6667 14.6666H3.33333C2.97971 14.6666 2.64057 14.5261 2.39052 14.2761C2.14048 14.026 2 13.6869 2 13.3333V5.99992Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M6 14.6667V8H10V14.6667" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export const Learn: FC<IconProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    {...props}
  >
    <path
      d="M1.3335 2H5.3335C6.04074 2 6.71902 2.28095 7.21911 2.78105C7.71921 3.28115 8.00016 3.95942 8.00016 4.66667V14C8.00016 13.4696 7.78945 12.9609 7.41438 12.5858C7.0393 12.2107 6.5306 12 6.00016 12H1.3335V2Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6667 2H10.6667C9.95942 2 9.28115 2.28095 8.78105 2.78105C8.28095 3.28115 8 3.95942 8 4.66667V14C8 13.4696 8.21071 12.9609 8.58579 12.5858C8.96086 12.2107 9.46957 12 10 12H14.6667V2Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const QuestionMark: FC<IconProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    {...props}
  >
    <path
      d="M8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M8 11.5H8.00667" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8 9.5V8" strokeLinecap="round" />
    <path
      d="M7.99994 8C9.10451 8 9.99994 7.10457 9.99994 6C9.99994 4.89543 9.10451 4 7.99994 4C7.34165 4 6.75764 4.31804 6.39319 4.80885"
      strokeLinecap="round"
    />
  </svg>
)

export const Competition: FC<IconProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    {...props}
  >
    <path
      d="M8 11.5V14.5M8 11.5C6.04067 11.5 4.37381 10.2478 3.75606 8.5M8 11.5C9.95933 11.5 11.6262 10.2478 12.2439 8.5M8 14.5H10.5M8 14.5H5.5M3.75606 8.5C3.59023 8.03083 3.5 7.52595 3.5 7V4.5M3.75606 8.5H3.5C2.39543 8.5 1.5 7.60457 1.5 6.5V4.5H3.5M3.5 4.5V2.5H12.5V4.5M12.5 4.5V7C12.5 7.52595 12.4098 8.03083 12.2439 8.5M12.5 4.5H14.5V6.5C14.5 7.60457 13.6046 8.5 12.5 8.5H12.2439"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const Pumpkin: FC<IconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 2"
    viewBox="0 0 32 32"
    width="16"
    height="16"
    fill="none"
    stroke="currentColor"
    {...props}
  >
    <path
      d="M19,7h-.1a3.686,3.686,0,0,1,.441-1.765,2.168,2.168,0,0,0-.053-2.155,2.222,2.222,0,0,0-3.211-.657A7.439,7.439,0,0,0,13.143,7H13a11,11,0,0,0,0,22h6A11,11,0,0,0,19,7ZM16.7,19H15.3a.3.3,0,0,1-.266-.431l.7-1.405a.3.3,0,0,1,.532,0l.7,1.405A.3.3,0,0,1,16.7,19ZM9.069,15.331l2.022-3.117a.5.5,0,0,1,.819,0l2.022,3.117a.442.442,0,0,1-.409.669H9.478A.442.442,0,0,1,9.069,15.331ZM19,25H17V24H15v1H13a3,3,0,0,1-3-3,1,1,0,0,1,1-1h1v1h2V21h4v1h2V21h1a1,1,0,0,1,1,1A3,3,0,0,1,19,25Zm3.522-9H18.478a.442.442,0,0,1-.409-.669l2.022-3.117a.5.5,0,0,1,.819,0l2.022,3.117A.442.442,0,0,1,22.522,16Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
